import { render, staticRenderFns } from "./MaterialNow.vue?vue&type=template&id=b56462b2"
import script from "./MaterialNow.vue?vue&type=script&lang=js"
export * from "./MaterialNow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports